import { Color } from "three";
import { LineGeometry } from "three/examples/jsm/lines/LineGeometry.js";
export const LOCKED_COLOR = new Color(0xdbdee3);
export const DEFAULT_X_AXIS_COLOR_ACTIVE = new Color(0xff6c93);
export const DEFAULT_X_AXIS_COLOR_INACTIVE = new Color(0xffdae0);
export const DEFAULT_Y_AXIS_COLOR_ACTIVE = new Color(0x6cffcc);
export const DEFAULT_Y_AXIS_COLOR_INACTIVE = new Color(0xdaffee);
export const DEFAULT_Z_AXIS_COLOR_ACTIVE = new Color(0x6cd8ff);
export const DEFAULT_Z_AXIS_COLOR_INACTIVE = new Color(0xdaf2ff);
export const DEFAULT_XYZ_AXIS_COLOR_ACTIVE = new Color(0xffd86c);
export const DEFAULT_XYZ_AXIS_COLOR_INACTIVE = new Color(0xfff2da);
export const DEFAULT_XY_AXIS_COLOR_ACTIVE = new Color(0xffff00);
export const DEFAULT_XY_AXIS_COLOR_INACTIVE = new Color(0xffffde);
export const DEFAULT_YZ_AXIS_COLOR_ACTIVE = new Color(0x00ffff);
export const DEFAULT_YZ_AXIS_COLOR_INACTIVE = new Color(0xdeffff);
export const DEFAULT_XZ_AXIS_COLOR_ACTIVE = new Color(0xff00ff);
export const DEFAULT_XZ_AXIS_COLOR_INACTIVE = new Color(0xffdeff);
export const DEFAULT_XYZX_AXIS_COLOR_ACTIVE = new Color(0xffffff);
export const DEFAULT_XYZX_AXIS_COLOR_INACTIVE = new Color(0xd5d5d5);
export const DEFAULT_XYZY_AXIS_COLOR_ACTIVE = new Color(0xffffff);
export const DEFAULT_XYZY_AXIS_COLOR_INACTIVE = new Color(0xd5d5d5);
export const DEFAULT_XYZZ_AXIS_COLOR_ACTIVE = new Color(0xffffff);
export const DEFAULT_XYZZ_AXIS_COLOR_INACTIVE = new Color(0xd5d5d5);
export const DEFAULT_E_AXIS_COLOR_ACTIVE = new Color(0xffd86c);
export const DEFAULT_E_AXIS_COLOR_INACTIVE = new Color(0xfff2da);
export const DEFAULT_XYZE_AXIS_COLOR_ACTIVE = new Color(0xb6b6b6);
export const DEFAULT_XYZE_AXIS_COLOR_INACTIVE = new Color(0x686868);
export const DEFAULT_TRANSLATE_LINE_THICKNESS = 5.0;
export const DEFAULT_SCALE_LINE_THICKNESS = 5.0;
export const DEFAULT_ROTATE_LINE_THICKNESS = 5.0;
export const DEFAULT_OVERALL_LINE_THICKNESS = 5.0;
export const DEFAULT_INITIAL_ENTITY_ROTATION = [0, 0, 0];
export var Axis;
(function (Axis) {
    Axis["X"] = "X";
    Axis["Y"] = "Y";
    Axis["Z"] = "Z";
    Axis["XYZ"] = "XYZ";
    Axis["XY"] = "XY";
    Axis["XZ"] = "XZ";
    Axis["YZ"] = "YZ";
    Axis["XYZY"] = "XYZY";
    Axis["XYZX"] = "XYZX";
    Axis["XYZZ"] = "XYZZ";
    Axis["XYZE"] = "XYZE";
    Axis["E"] = "E";
})(Axis || (Axis = {}));
export var Mode;
(function (Mode) {
    Mode["translate"] = "translate";
    Mode["scale"] = "scale";
    Mode["rotate"] = "rotate";
})(Mode || (Mode = {}));
export const CircleGeometry = (radius, arc) => {
    const geometry = new LineGeometry();
    const vertices = [];
    for (let i = 0; i <= 64 * arc; ++i) {
        vertices.push(0, Math.cos((i / 32) * Math.PI) * radius, Math.sin((i / 32) * Math.PI) * radius);
    }
    geometry.setPositions(vertices);
    return geometry;
};
